// ** React Imports
import { ReactNode } from 'react';

// ** MUI Imports
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// ** Layout Imports
// !Do not remove this Layout import
import Layout from 'src/@core/layouts/Layout';

// ** Component Import
import ServerSideVerticalNavItems from './components/vertical/ServerSideNavItems';
import ServerSideHorizontalNavItems from './components/horizontal/ServerSideNavItems';

import VerticalAppBarContent from './components/vertical/AppBarContent';
import HorizontalAppBarContent from './components/horizontal/AppBarContent';

// ** Hook Import
import { useSettings } from 'src/@core/hooks/useSettings';
import { useDynamicTheme } from 'src/@core/theme/DynamicTheme';

import { Box } from '@mui/material';
import { Products, useGetProductLevel } from 'src/@core/utils/getProductLevel';

interface Props {
  children: ReactNode;
}

const CustomPlatformLogo = ({ imageSource }: { imageSource: string }) => {
  if (!imageSource) return null;

  return (
    <Box sx={{ width: '100%', height: '56px', display: 'grid', placeItems: 'center' }}>
      <img
        src={imageSource}
        alt="Custom platform logo"
        style={{
          objectFit: 'contain',
          width: '100%',
          height: '56px'
        }}
      />
    </Box>
  );
};

const UserLayout = ({ children }: Props) => {
  // ** Hooks
  const prod = useGetProductLevel();
  const { settings, saveSettings } = useSettings();
  const hidden = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const { companyLogo } = useDynamicTheme();

  return (
    <Layout
      hidden={hidden}
      settings={settings}
      saveSettings={saveSettings}
      {...(settings.layout === 'horizontal'
        ? {
            // ** Navigation Items
            //horizontalNavItems: HorizontalNavItems(),

            // Uncomment the below line when using server-side menu in horizontal layout and comment the above line
            horizontalNavItems: ServerSideHorizontalNavItems(),

            // ** AppBar Content
            horizontalAppBarContent: props => (
              <HorizontalAppBarContent
                hidden={hidden}
                settings={settings}
                saveSettings={saveSettings}
                setShowBackdrop={props.setShowBackdrop}
              />
            )
          }
        : {
            // ** Navigation Items
            //verticalNavItems: VerticalNavItems(),

            // Uncomment the below line when using server-side menu in vertical layout and comment the above line
            verticalNavItems: ServerSideVerticalNavItems(),
            ...(prod === Products.MyPortal &&
              companyLogo?.isDefaultPlatformLogo && {
                verticalNavMenuBranding: () => <CustomPlatformLogo imageSource={companyLogo?.logo ?? ''} />
              }),

            // ** AppBar Content
            verticalAppBarContent: props => (
              <VerticalAppBarContent
                hidden={hidden}
                settings={settings}
                saveSettings={saveSettings}
                setShowBackdrop={props.setShowBackdrop}
                toggleNavVisibility={props.toggleNavVisibility}
                showHelp={props.showHelp}
              />
            )
          })}>
      {children}
    </Layout>
  );
};

export default UserLayout;
